import { render, staticRenderFns } from "./PopupSearchCompany.vue?vue&type=template&id=20194336&scoped=true"
import script from "./PopupSearchCompany.vue?vue&type=script&lang=js"
export * from "./PopupSearchCompany.vue?vue&type=script&lang=js"
import style0 from "./PopupSearchCompany.vue?vue&type=style&index=0&id=20194336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20194336",
  null
  
)

export default component.exports